export var setBodyOverflow = function (add) {
    var body = document.body;
    var className = "overflow-hidden";
    if (add && !body.classList.contains(className)) {
        body.classList.add(className);
    }
    if (!add && body.classList.contains(className)) {
        body.classList.remove(className);
    }
};
//# sourceMappingURL=bodyOverflow.js.map